export const REPLIES_PAGE_SIZE = 20
export const REPLIES_PAGE_MARGIN = 4

/** A partir de este turno la crónica pasa a «En progreso». */
export const ADVENTURE_IN_PROGRESS_FROM_TURN = 5

/** Tiempo narrativo (prioridad de consecuencias duras). */
export function resolveNarrativeTime(adventure = {}) {
  const raw = String(adventure?.narrativeTime ?? adventure?.narrative_time ?? '')
    .toLowerCase()
    .trim()
  return raw === 'presente' ? 'presente' : 'pasado'
}

export function narrativeTimeLabel(value) {
  return resolveNarrativeTime({ narrativeTime: value }) === 'presente' ? 'Presente' : 'Pasado'
}

/**
 * Estado efectivo: Completada/Cancelada se respetan;
 * turn >= 5 → En progreso; resto → Abierta.
 */
export function resolveAdventureStatus(adventure = {}) {
  const stored = String(adventure?.status || '').trim()
  if (stored === 'Completada' || stored === 'Cancelada') return stored

  const turn = Number(adventure?.current_turn ?? adventure?.currentTurn)
  if (Number.isFinite(turn) && turn >= ADVENTURE_IN_PROGRESS_FROM_TURN) {
    return 'En progreso'
  }

  return 'Abierta'
}

/** Completada / Cancelada: la crónica sigue visible pero no admite posts nuevos. */
export function isAdventureClosedToReplies(adventure = {}) {
  const status = resolveAdventureStatus(adventure)
  return status === 'Completada' || status === 'Cancelada'
}

/**
 * Categoría mostrada: mission_type, o «Misión» si hay enlace al tablón.
 */
export function resolveAdventureMissionType(adventure = {}) {
  const explicit = String(adventure?.mission_type ?? adventure?.missionType ?? '').trim()
  if (explicit && explicit.toLowerCase() !== 'general') return explicit
  const mid =
    adventure?.mission_id ??
    adventure?.missionId ??
    adventure?.board_mission_id ??
    adventure?.boardMissionId ??
    null
  if (mid != null && Number(mid) > 0) return 'Misión'
  if (explicit) return explicit
  return 'General'
}

/** Reply counts as "free" for pagination and turn grouping. */
export function isFreeReply(reply) {
  if (!reply) return true
  const turnNumber = Number(reply.turn_number)
  if (!reply.turn_number || turnNumber <= 0) return true
  if (reply.turn_system_type === 'free') return true
  return false
}
